import { ViewportUtils } from "banco/util/viewport_utils";

export class FaqHelper {
  static init() {
    // First setup a click handler for the accordion. This will scroll the
    // accordion to the top of the viewport when it is opened. Delegated from
    // the document since there can be multiple accordions with unique ids.
    $(document).off("shown.bs.collapse.faqHelper", ".accordion")
      .on("shown.bs.collapse.faqHelper", ".accordion", function() {
        const panel = $(this).find(".show").parent();
        ViewportUtils.scrollToElement(panel);
      });

    // Then check if we have an id in the URL. If so, we want to open the
    // accordion with that id.
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    const el = id && document.getElementById(id);

    if (el) {
      $(el).trigger("click");
    }
  }
}

window.banco.FaqHelper = FaqHelper;
